<script>
// TODO: move these function to utils folder later
function withThousandsSeparator(number) {
  const numberStr = String(number);
  let result = '';
  let count = 0;
  for (let i = numberStr.length - 1; i >= 0; i--) {
    result = numberStr[i] + result;
    count++;
    if (count === 3 && i !== 0) {
      result = ',' + result;
      count = 0;
    }
  }
  return result;
}

// drops non-digits characters function
function getNormalizedDigits(str) {
  if (typeof str !== 'string' || !str) return str;
  let result = '';
  for (const ch of str) {
    if (isPersianDigit(ch)) {
      result += String.fromCharCode(ch.charCodeAt(0) - 1776 + 48);
    } else if (isLatinDigit(ch)) {
      result += ch;
    }
  }
  return result;
}

function isPersianDigit(ch) {
  const charCode = ch.charCodeAt(0);
  return charCode >= 1776 && charCode <= 1785;
}
function isLatinDigit(ch) {
  const charCode = ch.charCodeAt(0);
  return charCode >= 48 && charCode <= 57;
}

export default {
  name: 'NumericInput',
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    withSeparator: {
      type: Boolean,
      default: false,
    },
    append: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      inputTextContent: this.transformValue(this.value),
    };
  },
  watch: {
    value() {
      this.inputTextContent = this.transformValue(this.value);
    },
  },
  methods: {
    transformValue(value) {
      const normalizedNumber = getNormalizedDigits(value);
      return this.withSeparator
        ? withThousandsSeparator(normalizedNumber)
        : normalizedNumber;
    },
    normalizeValueAndEmit(event) {
      const { value } = event.target;
      this.inputTextContent = this.transformValue(value);
      this.$refs.input.value = this.inputTextContent;
      const outputValue = this.inputTextContent
        .split(',')
        .filter(e => e !== ',')
        .join('');
      this.$emit('input', outputValue);
    },
  },
};
</script>

<template>
  <!-- <ElInput
    ref="input"
    type="tel"
    inputmode="decimal"
    :value="inputTextContent"
    v-bind="$attrs"
    @change="normalizeValueAndEmit"
  >
    <template v-if="append" #append>
      <span>{{ append }}</span>
    </template>
  </ElInput> -->

  <div class="el-input el-input-group el-input-group--append">
    <input
      ref="input"
      type="tel"
      autocomplete="off"
      inputmode="decimal"
      :value="inputTextContent"
      v-bind="$attrs"
      class="el-input__inner"
      @input="normalizeValueAndEmit"
    />
    <div v-if="append" class="el-input-group__append">
      <span>{{ append }}</span>
    </div>
  </div>
</template>
